import { ContentBox } from "components/elements";

import { TEXTS } from "../constants";
import styles from "./PublicationsLegend.scss";
import { PublicationStatus } from "./PublicationStatus";

export type PublicationsLegendProps = {
  className?: string;
};

export function PublicationsLegend({ className }: PublicationsLegendProps) {
  return (
    <div className={className}>
      <ContentBox title={TEXTS.LEGEND.TITLE}>
        <p className={styles.guide}>{TEXTS.LEGEND.GUIDE}</p>
        <p className={styles.status}>
          <PublicationStatus
            variantReleaseStages={["rs1"]}
            applicableReleaseStages={["rs1"]}
            publication={["rs1"]}
            releaseStage={"rs1"}
          />
          <span>{TEXTS.LEGEND.STATUS_PUBLISHED_PROMOTED}</span>
        </p>
        <p className={styles.status}>
          <PublicationStatus
            variantReleaseStages={["rs1"]}
            applicableReleaseStages={["rs1"]}
            publication={[]}
            releaseStage={"rs1"}
            isTargetValid={false}
          />
          <span>{TEXTS.LEGEND.STATUS_PROMOTED_BUT_CANNOT_BE_PUBLISHED}</span>
        </p>
        <p className={styles.status}>
          <PublicationStatus
            variantReleaseStages={["rs1"]}
            applicableReleaseStages={["rs1"]}
            publication={[]}
            releaseStage={"rs1"}
          />
          <span>{TEXTS.LEGEND.STATUS_NOT_PUBLISHED_PROMOTED}</span>
        </p>
        <p className={styles.status}>
          <PublicationStatus
            variantReleaseStages={[]}
            applicableReleaseStages={["rs1"]}
            publication={[]}
            releaseStage={"rs1"}
          />
          <span>{TEXTS.LEGEND.STATUS_NOT_PUBLISHED_NOT_PROMOTED}</span>
        </p>
        <p className={styles.status}>
          <PublicationStatus
            variantReleaseStages={[]}
            publication={[]}
            releaseStage={"rs1"}
          />
          <span>{TEXTS.LEGEND.STATUS_RS_NOT_AVAILABLE_ON_OEM}</span>
        </p>
      </ContentBox>
    </div>
  );
}
